/**
 * @mergeTarget
 * @module Src/Parameters/String/Options
 */
/**
 * Enumerator of options for {@link Src/Parameters/String.LisioStringParameterNames.DEEPL_TRANSLATION} parameter
 * @source
 */
var DeeplTranslationOptions;
(function (DeeplTranslationOptions) {
    DeeplTranslationOptions["FR"] = "FR";
    DeeplTranslationOptions["EN_GB"] = "EN_GB";
    DeeplTranslationOptions["ES"] = "ES";
    DeeplTranslationOptions["IT"] = "IT";
    DeeplTranslationOptions["DE"] = "DE";
    DeeplTranslationOptions["AR"] = "AR";
    DeeplTranslationOptions["EN_US"] = "EN_US";
    DeeplTranslationOptions["BG"] = "BG";
    DeeplTranslationOptions["ZH"] = "ZH";
    DeeplTranslationOptions["KO"] = "KO";
    DeeplTranslationOptions["DA"] = "DA";
    DeeplTranslationOptions["ET"] = "ET";
    DeeplTranslationOptions["FI"] = "FI";
    DeeplTranslationOptions["EL"] = "EL";
    DeeplTranslationOptions["HU"] = "HU";
    DeeplTranslationOptions["ID"] = "ID";
    DeeplTranslationOptions["JA"] = "JA";
    DeeplTranslationOptions["LV"] = "LV";
    DeeplTranslationOptions["LT"] = "LT";
    DeeplTranslationOptions["NL"] = "NL";
    DeeplTranslationOptions["NB"] = "NB";
    DeeplTranslationOptions["PL"] = "PL";
    DeeplTranslationOptions["PT_BR"] = "PT_BR";
    DeeplTranslationOptions["PT_PT"] = "PT_PT";
    DeeplTranslationOptions["RO"] = "RO";
    DeeplTranslationOptions["RU"] = "RU";
    DeeplTranslationOptions["SK"] = "SK";
    DeeplTranslationOptions["SL"] = "SL";
    DeeplTranslationOptions["SV"] = "SV";
    DeeplTranslationOptions["CS"] = "CS";
    DeeplTranslationOptions["TR"] = "TR";
    DeeplTranslationOptions["UK"] = "UK";
})(DeeplTranslationOptions || (DeeplTranslationOptions = {}));
export { DeeplTranslationOptions };
